import { CheckboxProps as MuiCheckboxProps } from "@mui/material"
import { FormControlLabelProps } from "@mui/material"
import { ReactNode } from "react"

export enum CheckboxColor {
  BLUE = "blue",
  GREEN = "green",
  ORANGE = "orange",
  PURPLE = "purple",
  YELLOW = "yellow",
  GREY = "grey",
  PLATINUM = "platinum",
}

type CheckboxBaseProps = Omit<MuiCheckboxProps, "color"> & {
  color?: CheckboxColor
}

type CheckboxProps = Omit<FormControlLabelProps, "control" | "label" | "color"> & {
  label?: ReactNode
  onCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
} & CheckboxBaseProps

export type { CheckboxProps, CheckboxBaseProps }
